import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { FuseConfigService } from "@fuse/services/config.service";
import { fuseAnimations } from "@fuse/animations";
import { AdminApi } from "@app/shared/sdk";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";

@Component({
  selector: "fuse-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  animations: fuseAnimations,
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginFormErrors: any;
  isRememberedFlag: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fuseConfig: FuseConfigService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private formBuilder: FormBuilder,
    private adminApi: AdminApi,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.fuseConfig.setConfig({
      layout: {
        navigation: "none",
        toolbar: "none",
        footer: "none",
      },
    });

    this.loginFormErrors = {
      email: {},
      password: {},
    };
  }

  ngOnInit() {
    if (this.adminApi.isAuthenticated()) {
      this.router.navigate(["/dashboard"]);
    }

    this.loginForm = this.formBuilder.group({
      email: [
        JSON.parse(localStorage.getItem("rememberMe")) !== null
          ? localStorage.getItem("email")
          : "",
        [Validators.required, Validators.email],
      ],
      password: ["", Validators.required],
      rememberMe: [
        JSON.parse(localStorage.getItem("rememberMe")) !== null
          ? localStorage.getItem("rememberMe")
          : "",
      ],
    });

    this.loginForm.valueChanges.subscribe(() => {
      this.onLoginFormValuesChanged();
    });
    this.fuseSplashScreenService.hide();
  }

  onLoginFormValuesChanged() {
    for (const field in this.loginFormErrors) {
      if (!this.loginFormErrors.hasOwnProperty(field)) {
        continue;
      }

      // Clear previous errors
      this.loginFormErrors[field] = {};

      // Get the control
      const control = this.loginForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.loginFormErrors[field] = control.errors;
      }
    }
  }
  isRemembered(flag) {
    this.isRememberedFlag = flag;
  }
  onSubmit() {
    this.isLoading = true;
    let credentials = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
    };
    this.adminApi.login(credentials, this.isRememberedFlag).subscribe(
      (response) => {
        localStorage.removeItem("email");
        localStorage.removeItem("rememberMe");
        if (this.loginForm.value.rememberMe) {
          localStorage.setItem("email", this.loginForm.value.email);
          localStorage.setItem(
            "rememberMe",
            JSON.stringify(this.loginForm.value.rememberMe)
          );
        }
        this.isLoading = false;
        this.snackBar.open(
          "Congratulations, you have successfully logged in",
          null,
          {
            verticalPosition: "top",
            duration: 2000,
          }
        );

        this.router.navigate(["/dashboard"]);
      },
      (error) => {
        this.isLoading = false;
        this.snackBar.open(
          "Email or Password is wrong! Please Enter Again.",
          "OK",
          {
            verticalPosition: "top",
            duration: 2000,
          }
        );
      }
    );
  }
}
